<div>
  @if (user) {
    <div class="fourHundred">
      <h1>Hold up. <img alt="" src="/utest-static/assets/images/smiling-face-with-sunglasses.png" /></h1>
      <h2>You need to sign in to see this page.</h2>
      <a [href]="loginHref" target="_self" class="btn btn-blue">Sign in</a>
    </div>
  }
  @if (!user) {
    <main class="fourHundredNotAuthorized">
      <img alt="" src="/utest-static/assets/images/smiling-face-with-sunglasses.png" /><br />
      <h1>Hold up. Authorization Required.</h1>
      <p>You need to log in or register to access this page.</p>
      <a [href]="loginHref" target="_self" class="btn btn-unauth">Sign in</a>
      &ngsp;<a uiSref="signup" target="_self" class="btn btn-unauth">Register</a>
    </main>
  }
</div>
